import { render, staticRenderFns } from "./OurHistory.vue?vue&type=template&id=4f26d20e&scoped=true&"
var script = {}
import style0 from "./OurHistory.vue?vue&type=style&index=0&id=4f26d20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f26d20e",
  null
  
)

export default component.exports